import Cache from 'admin/editor/cache';
import { debounce } from 'lodash';
import CodeMirror from 'utils/codemirror';
import hljs from 'highlight.js/lib/common';

export default class CodeElement {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedText = null;
    this.savedLanguage = null;
    this.savedLineNums = null;
    this.codeEditor = null;

    this.activeElementId = null;
    this.activePosition = null;

    this.cache = new Cache('code');

    this.init();
  }

  init() {
    this.prettyPrint();

    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on('click', '.add-build-code', this.newElement.bind(this));
    $(document).on(action, '.submit-build-code', this.submitElement.bind(this));
    $(document).on(action, '.cancel-build-code', this.cancelElement.bind(this));
    $(document).on(action, '.delete-build-code', this.deleteElement.bind(this));
    $(document).on(action, '.build-code', this.editElement.bind(this));
    $(document).on('change', '.code-select', this.handleCodeEditorLanguageChange.bind(this));
    this.learnEditor.$element.on('save-page-complete', this.prettyPrint);
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-code" href="#"><i class="fa fa-edit"></i>Code</a>';
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.savedText = null;
    this.savedLanguage = null;

    let cachedText = this.cache.get('text') || "";
    let cachedLanguage = this.cache.get('language') || "";

    this.insertCode(link.closest('.button-bar, .bottom-button-bar'), cachedText, cachedLanguage);
    this.learnEditor.editing();
  }

  submitElement(event) {
    event.preventDefault();
    let $element = $(event.currentTarget).closest('.build-code-wrapper');

    const text = this.codeEditor.getValue();
    const language = $('.code-select', $element).val();
    const lineNums = $('.code-linenums', $element).prop('checked');

    this.savedText = null;
    this.savedLanguage = null;
    this.savedLineNums = null;
    this.addCode($element, text, language, lineNums, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";
    this.learnEditor.save_page("Before Added Code Element");
  }

  editElement(event) {
    event.preventDefault();
    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    let $element = $(event.currentTarget);

    const text = $element.find('.code-text-only').text();

    let language = $element.data('language');
    // handle legacy scenario where linenums are not defined
    let lineNums = $element.data('linenums');

    const cachedText = this.cache.get('text');
    const cachedLanguage = this.cache.get('language');

    //backup the text, save it in case of cancelling
    this.savedText = text;
    this.savedLanguage = language;
    this.savedLineNums = lineNums;
    this.activeElementId = $element.attr('id');
    this.activePosition = $element.data('position');
    this.insertCode($element, cachedText || text, cachedLanguage || language, lineNums);
    this.learnEditor.centerInView($('.build-code-wrapper'));
    this.learnEditor.editing();
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    //restore with global saved text
    this.addCode($element.closest('.build-code-wrapper'),
                  this.savedText,
                  this.savedLanguage,
                  this.savedLineNums,
                  this.activeElementId,
                  this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.finishEditing();
    this.prettyPrint();
    this.cache.delete();
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    $element.closest('.build-code-wrapper').remove();

    this.savedText = null;
    this.savedLanguage = null;
    this.savedLineNums = null;
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Deleted Code Element");
    this.cache.delete();
  }

  insertCode($element, text, language, lineNums) {
    const buildText = this.buildCode(text, language, lineNums);

    $element.hide();
    let $build_text = $(buildText).hide();
    $element.replaceWith($build_text);
    $('.build-code-wrapper').show();

    this.learnEditor.centerInView($('.build-code-wrapper'));
    this.enableCodeEditor('code');

    this.watchState($build_text);
  }

  watchState($element) {
    let saveState = function(event) {
      const text = this.codeEditor.getValue(),
        language = $('.code-select', $element).val();

      this.cache.save({ text: text, language: language });
    }

    this.codeEditor.on('keyup', debounce(saveState.bind(this), 500));
    $element.find('select').on('change', debounce(saveState.bind(this), 500));
  }

  buildCode(text = "", language, lineNums) {
    if (text) {
      text = text.trim();
    }

    let buildText =
      `<div class='row-fluid build-code-wrapper'>
        ${this.codeSelectList(language)}
        <textarea id='code' class='build-textarea span12' name='code' style='display=block;'>${text}</textarea>
        <div class='clear'></div>
        <div class="editor-buttons">
          <button class='delete-build-code delete'>Delete</button>
          <button class='cancel-build-code cancel'>Cancel</button>
          <button class='submit-build-code save'>Save</button>
        </div>
      </div>`;

    let $buildText = $(buildText);

    return $buildText;
  }

  addCode($element, text, language, lineNums, id, position) {
    if (text) {
      text = text.trim();
      text = text.replace(/</g, "&lt;");
      text = text.replace(/>/g, "&gt;");
    }

    let codeHtml =
      `<div id='${id || ''}' class='element code-element build-code' data-position='${position}'>
        <pre class="code-text-only" style="display: none;">${text}</pre>
        <pre class='prettyprint'>${text}</pre>
      </div>`;

    let $codeHtml = $(codeHtml);

    if (language) {
      $codeHtml.attr('data-language', language);
      if (language === 'terminal') {
        $codeHtml.find('.prettyprint').addClass(language);
      } else if (language !== 'auto') {
        $codeHtml.find('.prettyprint').addClass(`language-${language}`);
      }
    }

    $codeHtml.find('.prettyprint').addClass('linenums');
    $codeHtml.attr('data-linenums', lineNums);

    if (text) {
      $element.replaceWith($codeHtml);
    } else {
      $element.remove();
    }
  }

  codeLineNumCheckbox(lineNums) {
    // handle the case where the metadata hasn't been set yet, let's default
    // to checked
    if (lineNums === '' || lineNums === undefined) {
      lineNums = true;
    }

    let lineNumCheckbox = `<div>
                            <label for='linenums'>
                              <input type='checkbox' id='linenums' class='code-linenums' ${ lineNums ? "checked" : "" }>
                            Include Line Numbers?
                            </label>
                           </div>`;

    return lineNumCheckbox;
  }

  codeSelectList(language) {
    let languageSelect = `<div><label for='code-select'>Choose a language (or Terminal option for no highlighting)</label>
            <select class='code-select select2'>
              <option value='auto'>auto detect</option>
              <option value='terminal'>terminal</option>
              <option value='python'>python</option>
              <option value='cpp'>arduino/c/c++</option>
              <option value='javascript'>javascript</option>
              <option value='ruby'>ruby</option>
              <option value='html'>html</option>
              <option value='java'>java</option>
              <option value='php'>php</option>
              <option value='xml'>xml</option>
            </select></div>`;

    if (language) {
      languageSelect = $(languageSelect);
      languageSelect.find(`option[value="${language}"]`).attr('selected', 'selected');

      return languageSelect[0].outerHTML;
    }

    return languageSelect;
  }

  enableCodeEditor(element) {
    CodeMirror.modeURL = "/codemirror/mode/%N/%N.js";
    this.codeEditor = CodeMirror.fromTextArea(document.getElementById(element), {
      lineNumbers: true,
      theme: 'default'
    });
    var language = $('.code-select').val();
    this.changeCodeEditorLanguage(language);

    // enable select2 for the code selection list
    $('.select2').select2({
      width: 'resolve'
    });
  }

  handleCodeEditorLanguageChange(event) {
    let language = $(event.currentTarget).val();
    this.changeCodeEditorLanguage(language);
  }

  changeCodeEditorLanguage(language) {
    if (language === 'html') {
      language = 'htmlmixed';
    } else if (language === 'java' || language === 'cpp') {
      language = 'clike';
    } else if (language === 'terminal') {
      language = 'null';
    }

    this.codeEditor.setOption("mode", language);
    CodeMirror.autoLoadMode(this.codeEditor, language);
  }

  prettyPrint() {
    document.querySelectorAll('pre.prettyprint').forEach(block => {
      hljs.highlightElement(block);
    });
  }
}
